module.exports = __webpack_public_path__ + "img/img_life-skills.35bcc6f7.png";